import { usePlatformUpdate } from '@reapitform/hooks'
import { IDefaultEmergencyContact, TEmergencyContactSchema } from '../../types'

export const useDefaultEmergencyContactPost = () => {
  const path: string = '/api/Organization/DefaultRepairer'

  const [addEmergencyContact, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<
    TEmergencyContactSchema,
    IDefaultEmergencyContact
  >({
    path: path,
    method: 'POST',
    headers: {},
    errorMessage: 'Failed to add new repairer',
    successMessage: 'Repairer successfully added',
  })

  return { addEmergencyContact, returnData, isLoading, isSuccess, isError }
}
